import type React from "react";
import {Box} from "@mui/material";
import {ChevronLeft, ChevronRight} from "@mui/icons-material";
import {COLORS} from "~/style/colors-ts";
import type {ValueChainDirection} from "~/pages/supplier-360/tabs/SupplierValueChain/valueChainLinkTypes";

const SIZE = 24;

type ChainTierArrowProps = {
    /** The side the card is on — its next tier opens further out on that side. */
    direction: ValueChainDirection;
    collapsed: boolean;
    /** e.g. "2 suppliers", for the tooltip. */
    childLabel: string;
};

/**
 * A round arrow on a card's outer edge, telling there's another tier behind it: pointing outwards
 * while that tier is hidden, inwards while it's shown. The click itself is handled by the card.
 */
export const ChainTierArrow: React.FC<ChainTierArrowProps> = ({direction, collapsed, childLabel}) => {
    const upstream = direction === 'upstream';
    // Upstream's next tier is to the left, downstream's to the right.
    const pointsLeft = upstream === collapsed;
    const Icon = pointsLeft ? ChevronLeft : ChevronRight;

    return (
        <Box
            component="span"
            title={`Click to ${collapsed ? 'show' : 'hide'} ${childLabel}`}
            sx={{
                position: 'absolute',
                top: '50%',
                [upstream ? 'left' : 'right']: -SIZE / 2,
                transform: 'translateY(-50%)',
                zIndex: 1,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: SIZE,
                height: SIZE,
                borderRadius: '50%',
                border: '1px solid',
                borderColor: collapsed ? COLORS.primary[500] : COLORS.primary[400],
                bgcolor: collapsed ? COLORS.primary[500] : COLORS.primary[100],
                color: collapsed ? 'common.white' : COLORS.primary[700],
                boxShadow: 1,
            }}
        >
            <Icon sx={{fontSize: 18}}/>
        </Box>
    );
};
